module.exports = __webpack_public_path__ + "static/media/img-heritage-area8-yahata03.2577eb58.jpg";